import React, { useEffect, useState, useRef } from "react";

export default function UnderConstruction() {
  const duration = 10;
  const [progress, setProgress] = useState(0);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [currentX, setCurrentX] = useState(0);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [showGlow, setShowGlow] = useState(false);
  const [showContactForm, setShowContactForm] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');
  const carouselRef = useRef(null);

  // Carousel data
  const slides = [
    {
      image: "/images/screenshot1.png",
      alt: "UrenApp Dashboard - Overzichtelijk tijdregistratie systeem",
      title: "Houd moeiteloos je uren bij",
      description: "Registreer je werkuren met één klik en krijg direct overzicht",
    },
    {
      image: "/images/screenshot1.png",
      alt: "UrenApp Projecten - Beheer al je projecten op één plek",
      title: "Organiseer projecten slim",
      description: "Koppel uren aan projecten en behoud het overzicht",
    },
    {
      image: "/images/screenshot1.png",
      alt: "UrenApp Rapportages - Inzichtelijke rapporten en analyses",
      title: "Krijg direct inzicht",
      description: "Genereer rapporten en analyseer je productiviteit",
    },
    {
      image: "/images/screenshot1.png",
      alt: "UrenApp Team - Samenwerken met collega's",
      title: "Werk samen met je team",
      description: "Deel projecten en synchroniseer realtime met collega's",
    }
  ];

  // Mouse tracking
  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
      setShowGlow(true);
    };

    const handleMouseLeave = () => setShowGlow(false);

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, []);

  // Clock animation
  useEffect(() => {
    let raf;
    let start = performance.now();
    function loop(now) {
      setProgress(((now - start) / 1000) / duration);
      raf = requestAnimationFrame(loop);
    }
    raf = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(raf);
  }, [duration]);

  // Auto-advance carousel
  useEffect(() => {
    if (!isDragging) {
      const interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % slides.length);
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [slides.length, isDragging]);

  const rotation = progress % 1;
  const secAngle = rotation * 360;
  const minAngle = (rotation * 6) % 360;
  const hourAngle = (rotation * 0.5) % 360;

  // Mouse/Touch handlers
  const handleStart = (clientX) => {
    setIsDragging(true);
    setStartX(clientX);
    setCurrentX(clientX);
  };

  const handleMove = (clientX) => {
    if (!isDragging) return;
    setCurrentX(clientX);
  };

  const handleEnd = () => {
    if (!isDragging) return;
    const diff = startX - currentX;
    const threshold = 50;

    if (Math.abs(diff) > threshold) {
      if (diff > 0) {
        setCurrentSlide((prev) => (prev + 1) % slides.length);
      } else {
        setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
      }
    }
    setIsDragging(false);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const getSlideStyle = (index) => {
    const diff = index - currentSlide;
    const adjustedDiff = diff > slides.length / 2 ? diff - slides.length : 
                        diff < -slides.length / 2 ? diff + slides.length : diff;
    
    const isVisible = Math.abs(adjustedDiff) <= 1;
    const translateX = adjustedDiff * 120;
    const translateZ = Math.abs(adjustedDiff) * -150;
    const rotateY = adjustedDiff * -25;
    const opacity = !isVisible ? 0 : 1 - Math.abs(adjustedDiff) * 0.3;
    const scale = 1 - Math.abs(adjustedDiff) * 0.2;

    return {
      transform: `translateX(${translateX}px) translateZ(${translateZ}px) rotateY(${rotateY}deg) scale(${scale})`,
      opacity,
      zIndex: slides.length - Math.abs(adjustedDiff),
      pointerEvents: !isVisible ? 'none' : 'auto',
    };
  };

  // Form handlers
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('');

    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitStatus('success');
      setFormData({ name: '', email: '', message: '' });
      
      setTimeout(() => {
        setShowContactForm(false);
        setSubmitStatus('');
      }, 3000);
    }, 1500);
  };

  return (
    <div>
      <style>
        {`
        html, body { margin: 0; padding: 0; -webkit-font-smoothing: antialiased; }
        @keyframes loaderPulse {
          0% { box-shadow: 0 0 0 0 rgba(251, 191, 36, 0.25); }
          70% { box-shadow: 0 0 0 24px transparent; }
          100% { box-shadow: 0 0 0 0 transparent; }
        }
        @keyframes slideDown {
          0% { 
            opacity: 0; 
            transform: translateY(-30px) scale(0.95);
            max-height: 0;
            filter: blur(10px);
          }
          50% {
            opacity: 0.7;
            transform: translateY(-10px) scale(0.98);
            filter: blur(5px);
          }
          100% { 
            opacity: 1; 
            transform: translateY(0) scale(1);
            max-height: 800px;
            filter: blur(0px);
          }
        }
        @keyframes slideUp {
          0% { 
            opacity: 1; 
            transform: translateY(0) scale(1);
            max-height: 800px;
            filter: blur(0px);
          }
          50% {
            opacity: 0.3;
            transform: translateY(-10px) scale(0.98);
            filter: blur(5px);
          }
          100% { 
            opacity: 0; 
            transform: translateY(-30px) scale(0.95);
            max-height: 0;
            filter: blur(10px);
          }
        }
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        .clock-loader { animation: loaderPulse 2.2s infinite; }
        .contact-button {
          background: linear-gradient(135deg, 
            #fbbf24 0%, 
            #ffd95a 25%,
            #fbbf24 50%,
            #f59e0b 75%,
            #fbbf24 100%
          );
          background-size: 300% 300%;
          color: #1f2937;
          font-weight: 900;
          font-size: 1.25rem;
          border: none;
          padding: 1.3rem 3rem;
          border-radius: 2.5rem;
          box-shadow: 
            0 12px 40px rgba(251, 191, 36, 0.4),
            0 6px 20px rgba(251, 191, 36, 0.3),
            inset 0 1px 0 rgba(255, 255, 255, 0.8),
            inset 0 -1px 0 rgba(0, 0, 0, 0.1);
          transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
          cursor: pointer;
          margin-bottom: 2.5rem;
          text-shadow: 0 1px 2px rgba(255, 255, 255, 0.5);
          letter-spacing: 0.02em;
          position: relative;
          overflow: hidden;
          animation: gradientShift 3s ease-in-out infinite;
        }
        .contact-button::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(45deg, 
            transparent 30%,
            rgba(255, 255, 255, 0.3) 50%,
            transparent 70%
          );
          transform: translateX(-100%);
          transition: transform 0.6s ease;
        }
        .contact-button:hover {
          background: linear-gradient(135deg, 
            #ffc600 0%, 
            #ffd95a 25%,
            #ffc600 50%,
            #fbbf24 75%,
            #ffc600 100%
          );
          transform: translateY(-4px) scale(1.05);
          box-shadow: 
            0 16px 50px rgba(251, 191, 36, 0.5),
            0 8px 30px rgba(251, 191, 36, 0.4),
            inset 0 1px 0 rgba(255, 255, 255, 0.9),
            inset 0 -1px 0 rgba(0, 0, 0, 0.05);
          letter-spacing: 0.5px;
        }
        .contact-button:hover::before {
          transform: translateX(100%);
        }
        .contact-form-container {
          width: 100%;
          max-width: 520px;
          margin: 0 auto;
          overflow: hidden;
          animation: ${showContactForm ? 'slideDown' : 'slideUp'} 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
          transform-origin: center top;
        }
        .contact-form {
          background: linear-gradient(145deg, 
            rgba(255, 255, 255, 0.12) 0%,
            rgba(255, 255, 255, 0.08) 50%,
            rgba(255, 255, 255, 0.05) 100%
          );
          backdrop-filter: blur(40px) saturate(180%);
          border: none;
          border-radius: 2.8rem;
          padding: 3.5rem 3rem;
          margin: 0 1rem;
          box-shadow: 
            0 32px 100px rgba(0, 0, 0, 0.25),
            0 16px 50px rgba(34, 71, 213, 0.15),
            0 8px 32px rgba(251, 191, 36, 0.08),
            inset 0 1px 0 rgba(255, 255, 255, 0.15),
            inset 0 -1px 0 rgba(255, 255, 255, 0.05);
          transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
          position: relative;
          overflow: hidden;
        }
        .contact-form::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 1px;
          background: linear-gradient(90deg, 
            transparent 0%,
            rgba(251, 191, 36, 0.3) 20%,
            rgba(251, 191, 36, 0.8) 50%,
            rgba(251, 191, 36, 0.3) 80%,
            transparent 100%
          );
        }
        .contact-form:hover {
          background: linear-gradient(145deg, 
            rgba(255, 255, 255, 0.15) 0%,
            rgba(255, 255, 255, 0.10) 50%,
            rgba(255, 255, 255, 0.08) 100%
          );
          box-shadow: 
            0 40px 120px rgba(0, 0, 0, 0.3),
            0 20px 60px rgba(34, 71, 213, 0.2),
            0 12px 40px rgba(251, 191, 36, 0.12),
            inset 0 1px 0 rgba(255, 255, 255, 0.2),
            inset 0 -1px 0 rgba(255, 255, 255, 0.08);
          transform: translateY(-2px);
        }
        .form-input {
          width: 100%;
          padding: 1.4rem 2rem;
          border: none;
          border-radius: 2rem;
          background: linear-gradient(145deg,
            rgba(255, 255, 255, 0.95) 0%,
            rgba(255, 255, 255, 0.9) 100%
          );
          color: #2247d5;
          font-size: 1.05rem;
          font-weight: 500;
          outline: none;
          transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
          box-sizing: border-box;
          margin-bottom: 2rem;
          backdrop-filter: blur(20px);
          box-shadow: 
            0 8px 32px rgba(0, 0, 0, 0.08),
            0 4px 16px rgba(34, 71, 213, 0.05),
            inset 0 1px 0 rgba(255, 255, 255, 1),
            inset 0 -1px 0 rgba(0, 0, 0, 0.02);
          position: relative;
        }
        .form-input:focus {
          background: linear-gradient(145deg,
            rgba(255, 255, 255, 1) 0%,
            rgba(255, 255, 255, 0.98) 100%
          );
          box-shadow: 
            0 0 0 6px rgba(251, 191, 36, 0.12),
            0 12px 40px rgba(251, 191, 36, 0.2),
            0 8px 25px rgba(0, 0, 0, 0.1),
            inset 0 1px 0 rgba(255, 255, 255, 1),
            inset 0 -1px 0 rgba(251, 191, 36, 0.1);
          transform: translateY(-3px) scale(1.01);
        }
        .form-input::placeholder {
          color: rgba(107, 114, 128, 0.7);
          font-weight: 400;
          transition: all 0.3s ease;
        }
        .form-input:focus::placeholder {
          color: rgba(107, 114, 128, 0.4);
          transform: translateY(-2px);
        }
        .form-submit {
          width: 100%;
          background: linear-gradient(135deg, 
            #fbbf24 0%, 
            #ffd95a 25%,
            #fbbf24 50%,
            #f59e0b 75%,
            #fbbf24 100%
          );
          background-size: 300% 300%;
          color: #1f2937;
          border: none;
          padding: 1.6rem 3rem;
          border-radius: 2.2rem;
          font-size: 1.2rem;
          font-weight: 900;
          cursor: pointer;
          transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
          box-shadow: 
            0 16px 50px rgba(251, 191, 36, 0.35),
            0 8px 25px rgba(251, 191, 36, 0.25),
            0 4px 15px rgba(0, 0, 0, 0.1),
            inset 0 1px 0 rgba(255, 255, 255, 0.8),
            inset 0 -1px 0 rgba(0, 0, 0, 0.1);
          text-shadow: 0 1px 2px rgba(255, 255, 255, 0.5);
          backdrop-filter: blur(10px);
          position: relative;
          overflow: hidden;
          animation: gradientShift 3s ease-in-out infinite;
        }
        @keyframes gradientShift {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }
        .form-submit::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, 
            transparent, 
            rgba(255, 255, 255, 0.5), 
            transparent
          );
          transition: left 0.6s ease;
        }
        .form-submit:hover:not(:disabled) {
          transform: translateY(-4px) scale(1.02);
          box-shadow: 
            0 20px 60px rgba(251, 191, 36, 0.4),
            0 12px 35px rgba(251, 191, 36, 0.3),
            0 6px 20px rgba(0, 0, 0, 0.15),
            inset 0 1px 0 rgba(255, 255, 255, 0.9),
            inset 0 -1px 0 rgba(0, 0, 0, 0.05);
          background: linear-gradient(135deg, 
            #ffc600 0%, 
            #ffd95a 25%,
            #ffc600 50%,
            #fbbf24 75%,
            #ffc600 100%
          );
          letter-spacing: 0.5px;
        }
        .form-submit:hover:not(:disabled)::before {
          left: 100%;
        }
        .form-submit:active:not(:disabled) {
          transform: translateY(-2px) scale(1.01);
        }
        .form-submit:disabled {
          background: linear-gradient(135deg, 
            #e5e7eb 0%, 
            #d1d5db 50%, 
            #9ca3af 100%
          );
          cursor: not-allowed;
          transform: none;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
          animation: none;
        }
        `}
      </style>
      
      <div
        style={{
          minHeight: "100dvh",
          width: "100vw",
          background: "radial-gradient(circle at 60% 35%, #4b8cf6 0%, #2247d5 100%)",
          overflowX: "hidden",
          position: "relative",
        }}
      >
        {/* Mouse Glow */}
        <div
          style={{
            position: "fixed",
            left: mousePosition.x - 200,
            top: mousePosition.y - 200,
            width: "400px",
            height: "400px",
            background: "radial-gradient(circle, rgba(251, 191, 36, 0.12) 0%, transparent 70%)",
            borderRadius: "50%",
            pointerEvents: "none",
            zIndex: 9999,
            opacity: showGlow ? 1 : 0,
            transition: "opacity 0.2s ease",
          }}
        />

        {/* Hero Section */}
        <div style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          paddingTop: "3rem",
          minHeight: "65vh"
        }}>
          <div style={{
            fontSize: "clamp(3rem, 8vw, 4.5rem)",
            fontWeight: 900,
            marginBottom: "2rem",
            textAlign: "center"
          }}>
            <span style={{ color: "#fff", textShadow: "0 4px 20px rgba(0,0,0,0.2)" }}>Uren</span>
            <span style={{ color: "#fbbf24", textShadow: "0 4px 20px rgba(251,191,36,0.3)" }}>App</span>
          </div>
          
          <div className="clock-loader" style={{
            background: "rgba(255,255,255,0.13)",
            borderRadius: "50%",
            padding: "2.9rem",
            marginBottom: "2.5rem",
            boxShadow: "0 12px 48px rgba(34, 71, 213, 0.3)"
          }}>
            <svg width="200" height="200" viewBox="0 0 100 100">
              <circle cx="50" cy="50" r="45" fill="#fff" stroke="#2247d5" strokeWidth="4" />
              {Array.from({ length: 12 }).map((_, i) => {
                const angle = ((i * 30) - 90) * (Math.PI / 180);
                return (
                  <line
                    key={i}
                    x1={50 + Math.cos(angle) * 36}
                    y1={50 + Math.sin(angle) * 36}
                    x2={50 + Math.cos(angle) * 43}
                    y2={50 + Math.sin(angle) * 43}
                    stroke="#2247d5"
                    strokeWidth="2.6"
                    opacity="0.30"
                  />
                );
              })}
              <rect x="48.7" y="53" width="2.6" height="17" rx="1.3" fill="#2247d5" opacity="0.77" 
                style={{ transform: `rotate(${hourAngle}deg)`, transformOrigin: "50% 50%" }} />
              <rect x="49.6" y="36" width="0.9" height="28" rx="0.6" fill="#4b8cf6" opacity="0.92" 
                style={{ transform: `rotate(${minAngle}deg)`, transformOrigin: "50% 50%" }} />
              <rect x="49.1" y="13" width="1.7" height="39" rx="1" fill="#fbbf24" 
                style={{ transform: `rotate(${secAngle}deg)`, transformOrigin: "50% 50%" }} />
              <circle cx="50" cy="50" r="3.2" fill="#fbbf24" stroke="#2247d5" strokeWidth="1.2" />
            </svg>
          </div>

          <h1 style={{
            color: "#fff",
            fontWeight: 900,
            fontSize: "clamp(2rem, 5vw, 3rem)",
            textAlign: "center",
            marginBottom: "1.5rem",
            lineHeight: 1.2
          }}>
            De Nieuwe Standaard in<br />
            <span style={{ color: "#fbbf24" }}>Urenregistratie</span>
          </h1>
          
          <p style={{
            color: "#fff",
            fontSize: "clamp(1rem, 2.5vw, 1.2rem)",
            opacity: 0.9,
            textAlign: "center",
            maxWidth: 500,
            margin: "0 auto 3rem auto",
            padding: "0 1rem",
            lineHeight: 1.6
          }}>
            Registreer moeiteloos je werkuren, beheer projecten en krijg direct inzicht in je productiviteit.
          </p>
          
          <div style={{
            display: "flex",
            gap: "2rem",
            justifyContent: "center",
            marginBottom: "6rem",
            flexWrap: "wrap",
            padding: "0 1rem"
          }}>
            <img src="/images/apple_button.webp" alt="Download UrenApp in de App Store" style={{ height: "60px", width: "203px" }} />
            <img src="/images/google_button.webp" alt="Download UrenApp op Google Play" style={{ height: "60px", width: "203px" }} />
          </div>
        </div>

        {/* Screenshots Carousel */}
        <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", marginBottom: "3rem", paddingTop: "4rem" }}>
          <div style={{
            position: "relative",
            width: "100%",
            maxWidth: "1200px",
            height: "600px",
            margin: "0 auto 1rem auto",
            perspective: "1200px",
            overflow: "visible"
          }}>
            <div style={{
              position: "relative",
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transformStyle: "preserve-3d"
            }}>
              {slides.map((slide, index) => (
                <div
                  key={index}
                  style={{
                    position: "absolute",
                    width: "375px",
                    transition: "all 0.6s cubic-bezier(0.4, 0.0, 0.2, 1)",
                    transformStyle: "preserve-3d",
                    ...getSlideStyle(index)
                  }}
                  onMouseDown={(e) => handleStart(e.clientX)}
                  onMouseMove={(e) => handleMove(e.clientX)}
                  onMouseUp={handleEnd}
                  onMouseLeave={handleEnd}
                  onTouchStart={(e) => handleStart(e.touches[0].clientX)}
                  onTouchMove={(e) => handleMove(e.touches[0].clientX)}
                  onTouchEnd={handleEnd}
                  onClick={() => index !== currentSlide && goToSlide(index)}
                >
                  <div style={{ position: "relative", transform: "translateZ(20px)", transition: "all 0.3s ease" }}>
                    <div style={{
                      color: "#fff",
                      textAlign: "center",
                      textShadow: "0 2px 10px rgba(0, 0, 0, 0.5)",
                      marginBottom: "1.2rem",
                      opacity: index === currentSlide ? 1 : 0,
                      transition: "opacity 0.3s ease"
                    }}>
                      <div style={{ fontSize: "1.3rem", fontWeight: 700, marginBottom: "0.4rem" }}>{slide.title}</div>
                      <div style={{ fontSize: "0.95rem", fontWeight: 400, opacity: 0.9, lineHeight: 1.4 }}>{slide.description}</div>
                    </div>
                    <img
                      src={slide.image}
                      alt={slide.alt}
                      style={{
                        width: "100%",
                        height: "auto",
                        display: "block",
                        borderRadius: "1.5rem",
                        boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
                        transition: "box-shadow 0.3s ease"
                      }}
                      loading={index === 0 ? "eager" : "lazy"}
                      draggable={false}
                    />
                  </div>
                </div>
              ))}
            </div>
            
            <div style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "100%",
              maxWidth: "800px",
              display: "flex",
              justifyContent: "space-between",
              pointerEvents: "none",
              zIndex: 5
            }}>
              <button 
                onClick={() => setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length)}
                style={{
                  width: "50px",
                  height: "50px",
                  background: "rgba(255,255,255,0.9)",
                  border: "none",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "1.5rem",
                  color: "#2247d5",
                  transition: "all 0.3s",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
                  pointerEvents: "all",
                  cursor: "pointer"
                }}
              >
                ‹
              </button>
              <button 
                onClick={() => setCurrentSlide((prev) => (prev + 1) % slides.length)}
                style={{
                  width: "50px",
                  height: "50px",
                  background: "rgba(255,255,255,0.9)",
                  border: "none",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "1.5rem",
                  color: "#2247d5",
                  transition: "all 0.3s",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
                  pointerEvents: "all",
                  cursor: "pointer"
                }}
              >
                ›
              </button>
            </div>
          </div>
          
          <div style={{
            display: "flex",
            justifyContent: "center",
            gap: "0.5rem",
            marginTop: "6rem",
            padding: "0.8rem 1.8rem",
            background: "rgba(255, 255, 255, 0.06)",
            backdropFilter: "blur(25px)",
            borderRadius: "2.5rem",
            border: "1px solid rgba(255, 255, 255, 0.08)",
            boxShadow: "0 12px 40px rgba(0, 0, 0, 0.15)"
          }}>
            {slides.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                style={{
                  width: "8px",
                  height: "8px",
                  borderRadius: "50%",
                  background: index === currentSlide ? "rgba(255,255,255,0.9)" : "rgba(255,255,255,0.25)",
                  border: "none",
                  transition: "all 0.5s cubic-bezier(0.4, 0, 0.2, 1)",
                  transform: index === currentSlide ? "scale(1.4)" : "scale(1)",
                  cursor: "pointer"
                }}
              />
            ))}
          </div>
        </div>

        {/* Contact Section */}
        <div style={{ textAlign: "center", marginBottom: "4rem" }}>
          <button 
            className="contact-button" 
            onClick={() => setShowContactForm(!showContactForm)}
          >
            💬 {showContactForm ? 'Contactformulier sluiten' : 'Neem contact op'}
          </button>
          
          {(showContactForm || submitStatus) && (
            <div className="contact-form-container">
              <div className="contact-form">
                {submitStatus === 'success' ? (
                  <div style={{ textAlign: "center", padding: "2rem 0" }}>
                    <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>✅</div>
                    <h3 style={{
                      color: "#10b981",
                      fontSize: "1.5rem",
                      fontWeight: "700",
                      marginBottom: "0.5rem",
                      textShadow: "0 2px 10px rgba(16, 185, 129, 0.3)"
                    }}>
                      Bericht verzonden!
                    </h3>
                    <p style={{ color: "rgba(255, 255, 255, 0.9)", margin: 0 }}>
                      We nemen zo snel mogelijk contact met u op.
                    </p>
                  </div>
                ) : (
                  <>
                    <h2 style={{
                      color: "#fff",
                      fontSize: "2.2rem",
                      fontWeight: "900",
                      textAlign: "center",
                      marginBottom: "0.8rem",
                      textShadow: "0 4px 20px rgba(0, 0, 0, 0.5)",
                      background: "linear-gradient(135deg, #fff 0%, rgba(251, 191, 36, 0.9) 100%)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      backgroundClip: "text",
                      letterSpacing: "-0.02em"
                    }}>
                      Contact opnemen
                    </h2>
                    <p style={{
                      color: "rgba(255, 255, 255, 0.85)",
                      fontSize: "1.1rem",
                      textAlign: "center",
                      marginBottom: "3rem",
                      textShadow: "0 2px 12px rgba(0, 0, 0, 0.4)",
                      lineHeight: 1.6,
                      fontWeight: 400
                    }}>
                      Heeft u vragen over UrenApp? We horen graag van u!
                    </p>
                    
                    <form onSubmit={handleSubmit}>
                      <input
                        type="text"
                        name="name"
                        placeholder="Uw naam"
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                        className="form-input"
                      />
                      
                      <input
                        type="email"
                        name="email"
                        placeholder="Uw e-mailadres"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        className="form-input"
                      />
                      
                      <textarea
                        name="message"
                        placeholder="Uw bericht"
                        value={formData.message}
                        onChange={handleInputChange}
                        required
                        rows={4}
                        className="form-input"
                        style={{
                          resize: "vertical",
                          minHeight: "120px",
                          fontFamily: "inherit",
                          marginBottom: "2rem"
                        }}
                      />
                      
                      <button
                        type="submit"
                        disabled={isSubmitting}
                        className="form-submit"
                      >
                        {isSubmitting ? (
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.5rem" }}>
                            <div style={{
                              width: "20px",
                              height: "20px",
                              border: "2px solid #2247d5",
                              borderTop: "2px solid transparent",
                              borderRadius: "50%",
                              animation: "spin 1s linear infinite"
                            }} />
                            Versturen...
                          </div>
                        ) : (
                          "📩 Bericht versturen"
                        )}
                      </button>
                    </form>
                  </>
                )}
              </div>
            </div>
          )}
        </div>

        {/* Footer */}
        <footer style={{
          textAlign: "center",
          color: "#fff",
          opacity: 0.14,
          fontSize: ".97em",
          margin: "2.2rem 0 .3rem 0",
          padding: "0 1rem"
        }}>
          © {new Date().getFullYear()} UrenApp • alle rechten voorbehouden
        </footer>
      </div>
    </div>
  );
}